import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlus, FiTrash2, FiUsers } = FiIcons;

function PeopleEditor({ people, onChange }) {
  function updatePerson(index, name) {
    onChange(people.map((person, itemIndex) =>
      itemIndex === index ? { ...person, name } : person
    ));
  }

  function addPerson() {
    onChange([...people, { localId: crypto.randomUUID(), name: '' }]);
  }

  function removePerson(index) {
    onChange(people.filter((_, itemIndex) => itemIndex !== index));
  }

  return (
    <div className="people-editor">
      <div className="field-heading">
        <span>
          <SafeIcon icon={FiUsers} />
          People
        </span>
        <button type="button" className="secondary-button compact" onClick={addPerson}>
          <SafeIcon icon={FiPlus} />
          Add Person
        </button>
      </div>

      <div className="people-list">
        {people.map((person, index) => (
          <div className="person-row" key={person.id || person.localId}>
            <span className="person-number">{index + 1}</span>
            <input
              type="text"
              value={person.name}
              onChange={(event) => updatePerson(index, event.target.value)}
              placeholder="Person name"
              aria-label={`Person ${index + 1} name`}
            />
            <button
              type="button"
              className="danger-icon-button"
              onClick={() => removePerson(index)}
              aria-label={`Remove ${person.name || `person ${index + 1}`}`}
            >
              <SafeIcon icon={FiTrash2} />
            </button>
          </div>
        ))}

        {!people.length && (
          <p className="empty-inline">No people added yet. Select “Add Person” to begin.</p>
        )}
      </div>
    </div>
  );
}

export default PeopleEditor;